/** GPS 座標平滑化の係数 (0〜1, 大きいほど追従性が高い) */
export const GPS_SMOOTHING_ALPHA = 0.25;

/** GPS 描画間引き間隔 (ms) */
export const GPS_DRAW_INTERVAL_MS = 50;
